import React, { useState } from 'react';

import { Table } from '@shared/components/ui/Table';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import dayjs from 'dayjs';
import ModificationModal from './ModificationModal';
import { Loading } from '@shared/components/ui/Loading';
import { useUpdateUserMemo, useDeleteUserMemo } from '@features/memo/hooks/useMemoQueries';


const useStyles = makeStyles((theme) => ({
  button: {},
  centeredHeader: {
    '& span': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
}));

const TableMemo = ({ memo }) => {
  const classes = useStyles();
  const [selectedRow, setSelectedRow] = useState();
  const [openModificationModal, setOpenModificationModal] = useState(false);

  // Utilisation des hooks React Query
  const updateMemoMutation = useUpdateUserMemo();
  const deleteMemoMutation = useDeleteUserMemo();

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'alarm_at',
      label: 'Date',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => dayjs(value).format('DD/MM/YYYY HH:mm'),
      },
    },
    {
      name: 'description',
      label: 'Description',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'add',
      label: 'Retarder',
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Button
              size="small"
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={() => {
                  const memo = tableMeta.rowData;
                  updateMemoMutation.mutate({
                    id: memo[0],
                    date: dayjs(memo[1]).add(5, 'minutes').toDate(),
                    description: memo[2]
                  });
              }}
            >
              + 5 min
            </Button>
          );
        },
      },
    },
    {
      name: 'remove',
      label: 'Avancer',
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Button
              size="small"
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={() => {
                  const memo = tableMeta.rowData;
                  updateMemoMutation.mutate({
                    id: memo[0],
                    date: dayjs(memo[1]).subtract(5, 'minutes').toDate(),
                    description: memo[2]
                  });
              }}
            >
              - 5 min
            </Button>
          );
        },
      },
    },

    {
      name: 'modify',
      label: 'Modifier',
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Button
                size="small"
                variant="contained"
                color="secondary"
                className={classes.button}
                onClick={() => {
                  handleModificationModal(tableMeta);
                }}
              >
                <EditIcon />
              </Button>
            </>
          );
        },
      },
    },
    {
      name: 'delete',
      label: 'Supprimer',
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Button
              size="small"
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={() => {
                deleteMemoMutation.mutate(tableMeta.rowData[0]);
              }}
            >
              <DeleteForeverIcon />
            </Button>
          );
        },
      },
    },
  ];

  const handleModificationModal = (tableMeta) => {
    setSelectedRow(tableMeta.rowData);
    setOpenModificationModal(true);
  };

  const handleCloseModificationModal = (event) => {
    setOpenModificationModal(false);
    setSelectedRow();
  };

  return (
    <>
      {memo ? <Table title={'Mes mémos'} data={memo} columns={columns} /> : <Loading />}
      {selectedRow && (
        <ModificationModal
          openModal={openModificationModal}
          handleCloseModal={handleCloseModificationModal}
          memo={selectedRow}
        />
      )}
    </>
  );
};

export default TableMemo;